import { Helmet } from "react-helmet-async"
import { CallLogsList } from "../../CallLogs"

export default function CallLogsPage() {
	return (
		<>
			<Helmet>
				<title>Call Logs</title>
			</Helmet>
			<CallLogsList />
		</>
	)
}
